import { Component, Input, OnInit } from "@angular/core";
import { forkJoin, take } from "rxjs";
import { FeatureFlag } from "@webapp/feature-toggles/models/feature-toggles.models";
import { FeatureTogglesFacade } from "@webapp/feature-toggles/services/feature-toggles-facade.service";
import { DropdownMenuItem } from "@webapp/shared/dropdown/dropdown.models";
import { IMetricContributorActionHandlers, IMetricContributorContext } from "../../models/metric-contributor-dropdown.models";
import { MetricContributorDropdownFacade } from "../../services/metric-contributor-dropdown-facade.service";

/**
 * @example <metric-contributor-dropdown [context]="metricContributorContext" [actionHandlers]="metricContributorActionHandlers"></metric-contributor-dropdown>
 * @param context the static context needed to build the dropdown items (including metric, goal, session, allowedActions)
 * @param actions the handler callback methods of the dropdown items
 */
@Component({
  selector: "metric-contributor-dropdown",
  templateUrl: "./metric-contributor-dropdown.component.html",
  styleUrls: ["./metric-contributor-dropdown.component.less"],
})
export class MetricContributorDropdownComponent implements OnInit {
  @Input() public context: IMetricContributorContext;
  @Input() public actionHandlers: IMetricContributorActionHandlers;
  public items: DropdownMenuItem[] = [];
  constructor(private metricContributorDropdownFacade: MetricContributorDropdownFacade, private featureToggleService: FeatureTogglesFacade) {}

  public ngOnInit(): void {
    forkJoin([
      this.featureToggleService.isFeatureAvailable$(FeatureFlag.A14UpdateKeyResult).pipe(take(1)),
      this.featureToggleService.isFeatureAvailable$(FeatureFlag.CascadingShouldDecreaseTo).pipe(take(1)),
    ]).subscribe(([isA14UpdateKeyResultEnabled, isCascadingShouldDecreaseToEnabled]) => {
      this.items = this.metricContributorDropdownFacade
        .setContextAndActions(this.context, this.actionHandlers, { a14UpdateKeyResult: isA14UpdateKeyResultEnabled, isCascadingShouldDecreaseToEnabled })
        .getItems();
    });
  }
}
